import { render, staticRenderFns } from "./SlidesLayout.vue?vue&type=template&id=6e6129f2&scoped=true&"
import script from "./SlidesLayout.vue?vue&type=script&lang=js&"
export * from "./SlidesLayout.vue?vue&type=script&lang=js&"
import style0 from "./SlidesLayout.vue?vue&type=style&index=0&id=6e6129f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6129f2",
  null
  
)

export default component.exports